import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_v_col = _resolveComponent("v-col");
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_v_card_actions = _resolveComponent("v-card-actions");
    const _component_ChangePostcodeDialog = _resolveComponent("ChangePostcodeDialog");
    const _component_v_row = _resolveComponent("v-row");
    const _component_v_card = _resolveComponent("v-card");
    return (_openBlock(), _createBlock(_component_v_card, {
        flat: "",
        tile: "",
        class: "pa-0"
    }, {
        default: _withCtx(() => [
            _createCommentVNode(" 도착지 주소  "),
            _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "4" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular brg-color-grey-600 pa-0" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('views.order_detail.order_detail_drop_info.drop_address')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_col, { cols: "8" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card_title, {
                                class: "text-force-break pa-0 body2-text font-weight-regular text-black",
                                "data-cy": "order-detail-drop-address"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.computedDropAddressShorten), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }),
                            (_ctx.isMobile && !_ctx.policy.isMaskingCustomerSafePhoneShow)
                                ? (_openBlock(), _createBlock(_component_v_card_actions, {
                                    key: 0,
                                    class: "pt-3 pb-0 px-0"
                                }, {
                                    default: _withCtx(() => [
                                        (_ctx.isMobile && !!_ctx.customerSafePhone)
                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 0,
                                                class: "btn-outlined-basic me-2",
                                                variant: "outlined",
                                                width: "100%",
                                                height: "40",
                                                href: `tel:${_ctx.customerSafePhone}`
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('views.order_detail.order_detail_drop_info.phone')), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["href"]))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    _: 1 /* STABLE */
                                }))
                                : _createCommentVNode("v-if", true),
                            (!_ctx.isHQ && _ctx.isChangeDropAddressAvailable)
                                ? (_openBlock(), _createBlock(_component_v_card_actions, {
                                    key: 1,
                                    class: "pt-3 pb-0 px-0"
                                }, {
                                    default: _withCtx(() => [
                                        _createCommentVNode(" 도착지 주소 변경 다이얼로그 "),
                                        _createVNode(_component_ChangePostcodeDialog, { order: _ctx.order }, {
                                            activator: _withCtx((props) => [
                                                _createCommentVNode(" 주소 변경 버튼 "),
                                                (!_ctx.isQuick)
                                                    ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({ key: 0 }, props, {
                                                        class: "btn-outlined-basic",
                                                        "data-cy": "change-address-button",
                                                        variant: "outlined",
                                                        width: "100%",
                                                        height: "40"
                                                    }), {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.$t('views.order_detail.order_detail_drop_info.change_address')), 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
                                                    : _createCommentVNode("v-if", true)
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["order"])
                                    ]),
                                    _: 1 /* STABLE */
                                }))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            }),
            _createCommentVNode(" 고객 전화번호  "),
            (_ctx.isShowCustomerPhone)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 0,
                    "no-gutters": "",
                    class: "mt-4"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular brg-color-grey-600 pa-0" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('views.order_detail.order_detail_drop_info.customer_safe_phone')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular text-black pa-0" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.customerPhoneWithHypen), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }))
                : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
    }));
}
